import prodotti from '@/services/prodottiService.js'
import configurazioni from '@/services/configurazioniService.js'
import movimenti from '@/services/movimentiService.js'
import clienti from '@/services/clientiService.js'
import documenti from '@/services/documentiService.js'

export const insomnia = {
  data() {
    return {
    }
  },
  methods: {
    async cicleSyncProcess() {
      try {
        await prodotti.cicleSync()
        await configurazioni.cicleSync()
        await movimenti.cicleSync()
        await clienti.cicleSync()
        await documenti.cicleSync()
      } catch (error) {
        console.log ('errore cicleSyncProcess', error)
      }
    }
  }
}